import Base from './Base';
import UserIntegration from '../models/UserIntegration';

export default class UserIntegrations extends Base {
    get models() {
        const collection = this.data.map(item => new UserIntegration(item));
        collection.collection = this;

        return collection;
    }
}
